import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    if (protocol === 'https:' || port === '80' || port === '443') return '';
    return `${protocol}//${hostname}:5000`;
  }
  return 'http://localhost:5000';
};

const EsqueciSenha = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage(null);
    setLoading(true);
    try {
      const res = await axios.post(`${getApiBaseUrl()}/api/auth/esqueci-senha`, { email: email.trim() });
      setMessage(res.data?.message || 'Se existir uma conta com este e-mail, você receberá um link para redefinir a senha.');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card glass">
        <div className="login-header">
          <img src="/logo.png" alt="Green Check" className="login-logo" />
          <h1>Recuperar senha</h1>
          <p className="text-muted">Informe seu e-mail para receber o link de redefinição</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <div className="form-group">
            <label>E-mail</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu@email.com"
              disabled={!!message}
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading || !!message}>
            {loading ? 'Enviando…' : 'Enviar link'}
          </button>
          <p className="login-footer">
            <Link to="/login">Voltar ao login</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default EsqueciSenha;
